import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/integration';

export default {
	// Get Accounts
	getAccounts(params, cb, errorCb) {
		const url = `${endpoint}`;
		client.get(url, { params })
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Remove Integration
	remove(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.delete(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Facebook
	addFacebook(params, cb, errorCb) {
		const url = `${endpoint}/facebook`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Google
	addGoogle(params, cb, errorCb) {
		const url = `${endpoint}/google`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Slack
	addSlack(params, cb, errorCb) {
		const url = `${endpoint}/slack`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Email
	addEmail(params, cb, errorCb) {
		const url = `${endpoint}/email`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add MailChimp
	addMailChimp(params, cb, errorCb) {
		const url = `${endpoint}/mailchimp`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add MailChimp
	addKirimEmail(params, cb, errorCb) {
		const url = `${endpoint}/kirimemail`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add GetResponse
	addGetResponse(params, cb, errorCb) {
		const url = `${endpoint}/getresponse`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Moota
	addMoota(params, cb, errorCb) {
		const url = `${endpoint}/moota`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Moota
	updateMoota(id, params, cb, errorCb) {
		const url = `${endpoint}/moota/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Custom Domains
	addCustomDomain(params, cb, errorCb) {
		const url = `${endpoint}/custom_domain`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Zenziva Domains
	addZenziva(params, cb, errorCb) {
		const url = `${endpoint}/zenziva`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Waboxapp
	addWaboxapp(params, cb, errorCb) {
		const url = `${endpoint}/waboxapp`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Woowa
	addWoowa(params, cb, errorCb) {
		const url = `${endpoint}/woowa`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Woonotif
	addWoonotif(params, cb, errorCb) {
		const url = `${endpoint}/woonotif`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// update Waboxapp
	updateWaboxapp(id, params, cb, errorCb) {
		const url = `${endpoint}/waboxapp/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// update Woowa
	updateWoowa(id, params, cb, errorCb) {
		const url = `${endpoint}/woowa/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update Woonotif
	updateWoonotif(id, params, cb, errorCb) {
		const url = `${endpoint}/woonotif/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Add Custom Domains
	verifyCustomDomain(params, cb, errorCb) {
		const url = `${endpoint}/custom_domain/verify`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get MailChimp List
	getMailChimp(cb, errorCb) {
		const url = `${endpoint}/mailchimp/lists`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get GetResponse List
	getGetResponse(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/getresponse/campaigns?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get KirimEmail List
	getKirimEmail(cb, errorCb) {
		const url = `${endpoint}/kirimemail/lists`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Get Custom Domains
	getCustomDomains(cb, errorCb) {
		const url = `${endpoint}/custom_domains`;
		client.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Get FB Ad Accounts List
	getFBAdAccounts(cb, errorCb) {
		const url = `${endpoint}/facebook/ad_accounts`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get FB Custom Audiences List
	getFBCustomAudiences(adAccountId, cb, errorCb) {
		const url = `${endpoint}/facebook/custom_audiences?ad_account_id=${adAccountId}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Get FB Campaign By Ad Account Id
	getFBCampaign(params, cb, errorCb) {
		const url = `${endpoint}/facebook/campaign?${params}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	// Add Midtrans
	addMidtrans(params, cb, errorCb) {
		const url = `${endpoint}/midtrans`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// Update Midtrans
	updateMidtrans(id, params, cb, errorCb) {
		const url = `${endpoint}/midtrans/${id}`;
		client.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	// add facebook server side tracking
	addFbTracking(params, cb, errorCb) {
		const url = `${endpoint}/facebook/server_side_tracking`;
		client.post(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},

	// Update faccbook server side tracking
	updateFbTracking(id, params, cb, errorCb) {
		const url = `${endpoint}/facebook/server_side_tracking/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				}
			});
	},
};
